import toggleClass from 'utils/DOM/toggleClass'
import getById from 'utils/DOM/getById'
import getTemplate from 'utils/DOM/getTemplate'
import type { ToastContent, ToastItem } from './types'
import isArray from 'utils/validation/isArray'

let timeoutID
const wrap = getById('toast-wrap')
const toastContent = getById('toast-content')
const toastContentTemplate = getTemplate('toast-content-template')

function removeToast() {
  window.clearTimeout(timeoutID)
  toggleClass(wrap, 'show', false)
}

const buildSingleItem = (item: string | ToastItem): ToastItem => {
  if (typeof item === 'string') {
    return { text: item }
  }

  return item
}

const buildTemplateData = (content: ToastContent) => {
  const items: Array<ToastItem> = []

  if (isArray(content)) {
    content.forEach(item => items.push(buildSingleItem(item)))
  } else {
    items.push(buildSingleItem(content))
  }

  return { items }
}

function toastNotification(content: ToastContent, end = 2500) {
  if (timeoutID) {
    removeToast()
  }

  toastContent.innerHTML = toastContentTemplate(buildTemplateData(content))
  toggleClass(wrap, 'show', true)
  timeoutID = window.setTimeout(removeToast, end)
}

export default toastNotification
